import commonConfigURL from "@adapters/infrastructures/urlConfig/commonUrl";
import { ScripDetailMapper } from "@domains/mapper/Common/ScripDetailMapper";
class CommonRepository {
    constructor(http) {
        this.http = http;
    }
    async getScripDetailData(req) {
        const url = new URL(`${commonConfigURL.sidebar}/${req.symbol}`);
        const sidebarData = await this.http.makeApiCall({
            method: "GET",
            url: url.toString(),
        });
        return ScripDetailMapper(sidebarData.data);
    }
    async customConfig() {
        const url = commonConfigURL.web_config_access_reports + "web-config.json";
        let configResp = await this.http.makeApiCall({
            method: "GET",
            url: url.toString(),
            headers: new Headers({ Origin: "*" }),
            avoidSOURCE: true,
        });
        return configResp;
    }
}
export default CommonRepository;
